import { useMemo } from 'react';

import { useCurrentUserQuery } from 'shared/graphql';

import { useCurrentUserPermissions } from './useCurrentUserPermissions';
import { useHasSession } from './useHasSession';

export function useCurrentUser() {
  const hasSession = useHasSession();

  const { isSchoolAdmin, loading: permissionsLoading } = useCurrentUserPermissions();

  const {
    data: response,
    loading: userLoading,
    error,
  } = useCurrentUserQuery({
    skip: !hasSession,
    // Poll every 5 minute to keep the session alive.
    pollInterval: 1000 * 60 * 5,
  });

  const user = response?.user;

  const isBusinessAdminOrManager = useMemo(() => {
    const ownedOrganizations = user?.ownedOrganizations?.items ?? [];
    const managedOrganizations = user?.managerPreferences?.items ?? [];

    return ownedOrganizations.length > 0 || managedOrganizations.length > 0;
  }, [user]);

  return {
    user,
    /** @deprecated Use {@link user} instead. */
    userId: user?.id,
    loading: userLoading || permissionsLoading,
    error,
    /** @deprecated Use from `useCurrentUserPermissions`. */
    isAdmin: isSchoolAdmin,
    isBusinessAdminOrManager,
  };
}
